const ROUTE_TYPES = {
  SAME_DAY: 'SAME_DAY',
  EXPRESS_SCHEDULED: 'EXPRESS_SCHEDULED',
  EXPRESS: 'EXPRESS',
};

Object.freeze({
  ROUTE_TYPES,
});

export { ROUTE_TYPES };
